import { api } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import {
  CreateTaskWithRoutesPayload,
  RouteData,
} from 'app/containers/Task/slice/types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useCreateOrUpdateTaskRoutes = ({
  taskId,
}: {
  taskId?: number;
}) => {
  const envId = useSelector(selectSelectedEnvId) as number;

  const { state } = useLocation<{
    routesData?: CreateTaskWithRoutesPayload;
    routes?: RouteData[];
  }>();

  const {
    data: taskRoutes,
    isFetching,
  } = api.endpoints.getTaskRoutes.useQueryState(
    {
      envId,
      taskId: taskId as number,
    },
    { skip: !taskId },
  );

  return { taskRoutes: taskRoutes || state?.routes || [], isFetching };
};
